import { FormattedMessage as FM } from "react-intl";

import { useStore } from "storev2/formStore";
import { cn } from "tools/ui";

const colspan = "md:col-span-2 lg:col-span-2 xl:col-span-2";
const styleHead =
  "flex py-2 w-full lg:pt-1.5 md:col-span-2 lg:col-span-2 xl:col-span-2";

function FormHeader({ title, layout, recordId }) {
  const { findRecord } = useStore();
  const record = findRecord(layout.model, recordId);

  let titleValue = layout.model;
  // if (title && title.field) {
  //   const nameField_ = `${title.field}.`;
  //   if (record[nameField_]) {
  //     titleValue = record[nameField_];
  //   } else {
  //     titleValue = record[title.field];
  //   }
  //   if (titleValue instanceof Object) {
  //     titleValue = titleValue.rec_name;
  //   }
  // }

  return (
    <div id="form-header" className={cn(styleHead)}>
      <h1 className={cn("text-neutral-500 text-3xl", colspan)}>
        {titleValue && (
          <span className="font-light">
            <FM id={titleValue} />
          </span>
        )}
      </h1>
    </div>
  );
}

export default FormHeader;
